module.exports = __webpack_public_path__ + "img/bg_3.d7f1f767.png";